export default __webpack_public_path__ + "static/media/location.c2ff51a2.svg";